export const ROLE_PERSONAL_CONTENT = 'personal-content',
  ROLE_PERSONAL_CONTENT_COLLECTIONS = 'personal-content-collections';

export const PERSONAL_CONTENT_ROLES = [ROLE_PERSONAL_CONTENT, ROLE_PERSONAL_CONTENT_COLLECTIONS];
